import styled from "styled-components";

export const NavWrapper = styled.nav`
  height: 85px;
  background-color: ${(p) => (p.bgColor ? p.bgColor : "#fff")};
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const NavSection = styled.div`
  &.section-logo {
    display: flex;
    align-items: center;
  }

  &.section-nav {
    @media ${(p) => p.theme.breakpoints.md} {
      display: flex;
      align-items: center;
    }

    display: none;
  }

  &.section-buttons {
    @media ${(p) => p.theme.breakpoints.md} {
      width: auto;
      justify-content: flex-start;
    }

    display: flex;
    align-items: center;
    width: 100%;
    justify-content: flex-end;
  }

  &.section-menu-icon {
    @media ${(p) => p.theme.breakpoints.md} {
      display: none;
    }

    display: flex;
    align-items: center;
  }
`;

export const BrandLogo = styled.img`
  max-height: 70%;
`;

export const BrandText = styled.div`
  max-height: 70%;

  text-decoration: none;

  &:hover {
    text-decoration: none;
    cursor: pointer;
  }
`;

export const NavList = styled.ul`
  display: flex;
  align-items: center;
  list-style-type: none;
  margin-bottom: 0;
  padding: 0;
`;

export const NavListItem = styled.li`
  display: flex;
  flex-direction: column;
  padding: 10px;
  cursor: pointer;

  &:hover {
    .nav-text {
      color: ${(p) =>
        p.hoverColor
          ? p.hoverColor
          : p.theme.colors.secondary
          ? p.theme.colors.secondary
          : "#000"};
    }

    & .sub-nav {
      display: block;
    }
  }
`;

export const NavItemText = styled.span`
  font-size: 15px;
  color: ${(p) =>
    p.color ? p.color : p.theme.colors.font ? p.theme.colors.font : "#000"};
  white-space: nowrap;
`;

NavItemText.defaultProps = {
  className: "nav-text",
};

export const NavItemIcon = styled.i`
  margin-left: ${(p) => (!p.prepend ? "6px" : "")};
  margin-right: ${(p) => (p.prepend ? "6px" : "")};
`;

export const SubNavWrapper = styled.div`
  position: relative;
  cursor: default;
  z-index: 2000;
`;

export const SubNavList = styled.ul`
  display: none;
  position: absolute;
  top: 10px;
  left: ${(p) => p.left}px;
  padding: 20px 15px;
  width: ${(p) => p.width}px;
  background-color: ${(p) => (p.bgColor ? p.bgColor : "#fff")};
  list-style-type: none;
  border-radius: 4px;
  box-shadow: 0 14px 25px rgba(0, 0, 0, 0.12);
`;

SubNavList.defaultProps = {
  className: "sub-nav",
};

export const SubNavListItem = styled.li`
  display: flex;
  align-items: center;
  padding: 10px;
  cursor: pointer;

  &:hover {
    .icon-wrapper {
      background-color: ${(p) =>
        p.iconColor
          ? p.iconColor
          : p.theme.colors.primary
          ? p.theme.colors.primary
          : "rgba(0, 0, 0, 0.1)"};
    }

    .icon {
      color: #fff;
    }

    .heading,
    p {
      color: ${(p) =>
        p.hoverColor
          ? p.hoverColor
          : p.theme.colors.secondary
          ? p.theme.colors.secondary
          : "#000"};
    }
  }
`;

const hexToRgba = (hex, opacity) => {
  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split("");
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = "0x" + c.join("");
    return (
      "rgba(" +
      [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
      "," +
      opacity +
      ")"
    );
  }
  return;
};

export const NavListIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-right: ${(p) => (p.mobile ? "15px" : "20px")};
  width: ${(p) => (p.mobile ? "36px" : "48px")};
  min-width: ${(p) => (p.mobile ? "36px" : "48px")};
  height: ${(p) => (p.mobile ? "36px" : "48px")};
  border-radius: 50%;
  background-color: ${(p) => {
    const color = p.bgColor
      ? p.bgColor
      : p.theme.colors.primary
      ? p.theme.colors.primary
      : undefined;

    const defaultColor = "rgba(0, 0, 0, 0.1)";

    if (!color) {
      return defaultColor;
    }

    let result;

    if (color) {
      if (color[0] === "#") {
        result = hexToRgba(color, "0.1");
      } else if (color.startsWith("rgb(")) {
        const rgb = color.slice(4, color.indexOf(")"));
        result = `rgba(${rgb}, 0.5)`;
      } else {
        result = defaultColor;
      }
    }

    return result;
  }};
`;

NavListIconWrapper.defaultProps = {
  className: "icon-wrapper",
};

export const NavListIcon = styled.em`
  font-size: ${(p) => (p.mobile ? "16px" : "20px")};
  color: ${(p) =>
    p.color
      ? p.color
      : p.theme.colors.primary
      ? p.theme.colors.primary
      : "#000"};
`;

export const SubNavListText = styled.div``;

export const SubNavListHeading = styled.h4`
  margin-bottom: 0;
  font-weight: 400;
  color: ${(p) =>
    p.color ? p.color : p.theme.colors.font ? p.theme.colors.font : "#000"};
`;

SubNavListHeading.defaultProps = {
  className: "heading",
};

export const SubNavListDesc = styled.p`
  margin-top: 1px;
  margin-bottom: 0;
  font-size: ${(p) => (p.mobile ? "10px" : "12px")};
  color: ${(p) => (p.color ? p.color : "#787878")};
`;

export const Separator = styled.hr`
  margin: 10px 0;
  border: solid ${(p) => (p.color ? p.color : "#e8e8e8")};
  border-width: 1px 0 0;
`;

export const SubHeading = styled.h3`
  margin-bottom: 0;
  padding: 10px;
  font-size: 14px;
  font-weight: 400;
  text-transform: uppercase;
  color: ${(p) =>
    p.color
      ? p.color
      : p.theme.colors.secondary
      ? p.theme.colors.secondary
      : "#000"};
`;

export const PageLinkWrapper = styled.div`
  padding: 10px;
`;

export const PageLink = styled.span`
  font-size: 12px;
  color: ${(p) =>
    p.color
      ? p.color
      : p.theme.colors.secondary
      ? p.theme.colors.secondary
      : "#000"};
  cursor: pointer;

  &:hover {
    padding-bottom: 2px;
    border-bottom: 1px solid
      ${(p) =>
        p.color
          ? p.color
          : p.theme.colors.secondary
          ? p.theme.colors.secondary
          : "#000"};
  }
`;

export const Button = styled.button`
  @media ${(p) => p.theme.breakpoints.lg} {
    display: block;
  }

  display: ${(p) => (p.prio ? "block" : "none")};
  margin-left: 8px;
  padding: 0;
  background-color: ${(p) =>
    p.bgColor
      ? p.bgColor
      : p.theme.colors.primary
      ? p.theme.colors.primary
      : "#f5f5f5"};
  border: none;
  border-radius: 4px;
  box-shadow: ${(p) =>
    p.open ? `0 0 0 2px ${p.theme.colors.secondary}` : "none"};
  transition: box-shadow 200ms ease;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }

  &:focus {
    outline: none;
  }
`;

export const ButtonInner = styled.div`
  padding: 8px 16px;
  font-size: 13px;
  color: ${(p) =>
    p.color ? p.color : p.theme.colors.font ? p.theme.colors.font : "#000"};
  border-radius: 4px;
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }
`;

export const Avatar = styled.button`
  margin-left: 8px;
  padding: 0;
  width: 35px;
  height: 35px;
  background-color: ${(p) =>
    p.bgColor
      ? p.bgColor
      : p.theme.colors.primary
      ? p.theme.colors.primary
      : "#f5f5f5"};
  border-radius: 50%;
  border: none;
  box-shadow: ${(p) =>
    p.open ? `0 0 0 2px ${p.theme.colors.secondary}` : "none"};
  transition: box-shadow 200ms ease;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }

  &:focus {
    outline: none;
  }
`;

export const AvatarInner = styled.div`
  /* padding: 7px; */
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  font-size: 13px;
  color: ${(p) =>
    p.color ? p.color : p.theme.colors.font ? p.theme.colors.font : "#000"};
  border-radius: 50%;
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }
`;

export const Language = styled.button`
  margin-left: 8px;
  padding: 0;
  background-color: transparent;
  border: none;
  opacity: ${(p) => (p.active ? 1 : 0.3)};
  //transition: opacity 100ms ease;

  &:focus {
    outline: none;
  }

  &:hover {
    opacity: 1;
  }
`;

export const LanguageInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  cursor: pointer;
`;

export const MenuIcon = styled.em`
  margin-left: 15px;
  font-size: 22px;
  cursor: pointer;
`;
